const APPS_LOAD_BALANCER_URL = 'https://europe-west1-fao-agrito-reu.cloudfunctions.net';
const REVIEW_BASE_URL = 'https://agritechobservatory.review.fao.org';

export const PROD_ENDPOINTS = {
    CASCADE_FILTER : `${APPS_LOAD_BALANCER_URL}/fao-agrid-cascade-filter`,
    GET_SIMILAR_PROJECTS : `${APPS_LOAD_BALANCER_URL}/fao-agrid-get-similar-projects`,
    GET_PROJECT_BY_ID : `${APPS_LOAD_BALANCER_URL}/fao-agrid-get-project-by-id`,
}

export const REVIEW_ENDPOINTS = {
  CASCADE_FILTER: `${REVIEW_BASE_URL}/agrid-cascade-filter/`,
  GET_SIMILAR_PROJECTS: `${REVIEW_BASE_URL}/agrid-get-similar-projects/`,
  GET_PROJECT_BY_ID: `${REVIEW_BASE_URL}/agrid-get-project-by-id/`,
};

export const NUMBER_ITEMS = '1000'
export const PAGES = '1'

export const ITEMS_PER_PAGE = 12;
export const INITIAL_FILTERS: Filters = {
  type: [],
  country: [],
  use_case: [],
  theme: [],
  technology: [],
  business_model: [],
  maturity: [],
  fvc: [],
  users: [],
  organization_type: [],
  origin_country: [],
  sdg: [],
  four_betters: [],
};
